import {
  callApiGetCongViecPaging,
  callApiLayDanhSachCongViec,
  callApiLayDanhSachCongViecByNhiemVu,
  callApiTaoCongViec,
  callApiGetDonViTaoCongViec,
  callApiGetDonViGanCongViec,
  callApiUploadFile,
  callApiGetTrangThaiCv,
  callApiLayChiTietCongViecNhiemVu,
  callApiXoaCongViec,
  callApiHuyCongViec,
  callApiSuaCongViec,
  callApiLayDanhSachLichSuThayDoiTrangThaiCongViec,
  callApiLayDanhSachLichSuGiaoViec,
  callApiLayDanhSachMucDoCongViec,
  callApiGanCongViec,
} from "@/api/cong-viec";
import Vue from "vue";
import {callApiLayDanhSachLichSuDonDocCongViec,
} from "@/api/nhiem-vu";

const layCongViecPaging = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetCongViecPaging(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_CONG_VIEC_PAGING", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const layDanhSachCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachCongViec(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_CONG_VIEC", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_DANH_SACH_CONG_VIEC", []);
        reject(error);
      });
  });
};
const layDanhSachCongViecByNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachCongViecByNhiemVu(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_CONG_VIEC_LIEN_QUAN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const taoCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoCongViec(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const suaCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaCongViec(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const ganCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGanCongViec(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDonViTaoCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViTaoCongViec(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_TAO_CONG_VIEC", response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDonViTaoCongViecNotState = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViTaoCongViec(payload)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDonViGanCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViGanCongViec(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_GAN_CONG_VIEC", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const themMoiFile = (context, payload) => {
  return new Promise((resolve) => {
    callApiUploadFile(payload)
      .then((response) => {
        if (!response.data.IsSuccess) {
          Vue.toasted.global.showErrorMessage({
            message: response.data.Messages[0],
          });
        }
        resolve(response);
      })
      .catch((error) => {
        Vue.toasted.global.showErrorMessage({
          message: error,
        });
      });
  });
};

const layDanhSachTrangThaiCv = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetTrangThaiCv(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_TRANG_THAI_CONG_VIEC", response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layChiTietCongViecNhiemVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayChiTietCongViecNhiemVu(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_CHI_TIET_CONG_VIEC", response.data);
          resolve(response);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layChiTietCongViecNhiemVuNotState = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayChiTietCongViecNhiemVu(payload)
      .then((res) => {
        if (res) {
          resolve(res);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const setEmptyCongViec = (context, payload) => {
  context.commit("SET_CHI_TIET_CONG_VIEC", payload);
};

const xoaCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaCongViec(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const huyCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiHuyCongViec(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachLichSuThayDoiTrangThaiCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachLichSuThayDoiTrangThaiCongViec(payload)
      .then((response) => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_LICH_SU_THAY_DOI_TRANG_THAI_CONG_VIEC",
            response.data
          );
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachLichSuGiaoViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachLichSuGiaoViec(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_LICH_SU_GIAO_VIEC", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachMucDoCongViec = (context) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachMucDoCongViec()
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_MUC_DO_CONG_VIEC", response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachLichSuDonDocCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachLichSuDonDocCongViec(payload)
        .then((response) => {
          if (response) {
            context.commit(
                "SET_DANH_SACH_LICH_SU_DON_DOC_CONG_VIEC",
                response.data
            );
          }
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

const layDanhSachCotCongViec = (context, payload) => {
  context.commit("SET_DANH_SACH_COT_CONG_VIEC", payload);
};
const capNhatDanhSachCotCongViec = (context, payload) => {
  context.commit("CAP_NHAT_DANH_SACH_COT_CONG_VIEC", payload);
};

export default {
  layCongViecPaging,
  layDanhSachCongViec,
  layDanhSachCongViecByNhiemVu,
  taoCongViec,
  getDonViTaoCongViec,
  getDonViTaoCongViecNotState,
  getDonViGanCongViec,
  themMoiFile,
  layDanhSachTrangThaiCv,
  layChiTietCongViecNhiemVu,
  layChiTietCongViecNhiemVuNotState,
  xoaCongViec,
  huyCongViec,
  suaCongViec,
  layDanhSachLichSuThayDoiTrangThaiCongViec,
  layDanhSachLichSuGiaoViec,
  layDanhSachCotCongViec,
  capNhatDanhSachCotCongViec,
  ganCongViec,
  setEmptyCongViec,
  layDanhSachMucDoCongViec,
  layDanhSachLichSuDonDocCongViec,
};
